import { useState } from "react"
import InTheNewsCard from "components/InTheNewsCard"
import CallToAction from "components/CallToAction"
import { useRequestSending } from "utilities/useRequestSending"
import { BLOG_ARTICLES_PER_PAGE_ODD_SM } from "utilities/blogHelpers"
import { getArchiveCommunityPostsApi } from "storyblok/inYourCommunityApi"

export default function InYourCommunityCategoryArchive({ blok }) {
  const { items = [], currentPage = 1, total = 0, perPage = BLOG_ARTICLES_PER_PAGE_ODD_SM } = blok.communityPostsData || {}

  const [itemList, setItemList] = useState(items)
  const [page, setPage] = useState(currentPage)
  const isEnd = page * perPage - total >= 0;

  const { send, isSending } = useRequestSending(async () => getArchiveCommunityPostsApi({
    page: page + 1,
    perPage,
    category: blok.category
  }),
    {
      onSuccess({ items }) {
        setItemList((i) => [...i, ...items])
        setPage((p) => p + 1)
      }
    });

  return (
    <section className="bg-highlight-tint px-5 py-8 lg:py-16">
      {blok?.heading ? <h2 className="text-center text-primary lg:pb-4">{blok.heading}</h2> : null}
      <div>
        <div className="max-w-screen-xl mx-auto flex flex-col justify-center items-center w-full">
          <div className="grid sm:grid-cols-2 gap-8 py-8 w-full lg:grid-cols-3">
            {itemList.map((item) => (
              <InTheNewsCard {...item} key={item.name} />
            ))}
          </div>
          {!isEnd && (
            <CallToAction
              style="ghost"
              disabled={isSending}
              loading={isSending}
              button
              onClick={() => send()}>
              Load More
            </CallToAction>
          )}
        </div>
      </div>
    </section>
  )
}
